import React, { useState } from 'react';

import { NavBar } from 'apps/auth/components/common/Layout/NavBar/NavBar';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { resolveArguments } from 'apps/auth/helpers/utils';

import { CountrySearchBar } from './CountrySearchBar';
import FullCountryList from './FullCountryList';
import { NotFoundResult } from './NotFoundResult';

export const FullViewCountrySearch = (props) => {
    const [countryList, setCountryList] = useState({
        countryList: props.countries,
        hideLetter: false,
        query: '',
    });

    return (
        <ModalComponent canCloseModal={false} isVerticalCentered={countryList.countryList.length === 0}>
            {countryList.countryList.length > 0 ? (
                <FullCountryList
                    gotIt={props.gotIt}
                    userCountry={props.userCountry}
                    notificationText={props.notificationText}
                    countries={countryList.countryList}
                    hideLetter={countryList.hideLetter}
                    query={countryList.query}
                    recipientType={props.recipientType}
                    sendUrIPrefix={props.sendUrIPrefix}
                    sendUriPostfix={props.sendUriPostfix}
                    onCountryItemClick={props.onCountryItemClick}
                    ccyField={props.ccyField}
                    countryWithCode={props.countryWithCode}
                    iso2={props.iso2}
                    isRequest={props.isRequest}
                    showCurrency={props.showCurrency}
                    getSelectedCountry={props.getSelectedCountry}
                    sendBrazeEvent={props.sendBrazeEvent}
                />
            ) : (
                <NotFoundResult notFoundMessage={resolveArguments(props.searchNoResult, countryList.query)} />
            )}
            <NavBar isSearchBar>
                <CountrySearchBar
                    backUrl={props.backUrl}
                    setCountryList={setCountryList}
                    toggleSearch={props.toggleSearch}
                    setBackUrl={props.setBackUrl}
                    countries={props.countries}
                    placeholder={props.placeholder}
                />
            </NavBar>
        </ModalComponent>
    );
};
